import './assets/featured-articles-widget.css';
